<ion-content class="ion-padding">
  <div class="consent-done-panel">
    <i class="consent-done-icon"
       [ngClass]="succeeded() ? 'icon-ok consent-done-icon--success' : 'icon-warning consent-done-icon--failure'"></i>

    <h2 class="consent-done-title">{{ titleKey() | translate }}</h2>

    <!-- stringular fills the {0} brand placeholder, which ConsentWrongTenant carries and the
         other reason captions do not — it is a no-op for those. Same pattern as MyPrintixHome. -->
    <p class="consent-done-message" *ngIf="messageKey()">{{ messageKey() | translate | stringular: 'Printix' }}</p>

    <button class="btn btn-primary mt20" *ngIf="showConsentsLink()" (click)="goToConsents()">
      {{ 'SeeAllConsents' | translate }}
    </button>

    <!-- Wrong-tenant only, and the one outcome reached in-app: this page has no header and no back
         stack, so without an exit the user is stranded. 'Print' is what the menu calls /print-jobs. -->
    <button class="btn btn-primary mt20" *ngIf="showExitLink()" (click)="goToPrintJobs()">
      {{ 'Print' | translate }}
    </button>
  </div>
</ion-content>
